import { Controller } from "@hotwired/stimulus"

// Live amounts of a practitioner invoice's lines (« Factures réseau » edit modal): each line's amount, the total
// (VAT included, 20 %), its VAT and pre-tax parts, and what is left to pay with the earlier unpaid invoices.
// The server recomputes them on save (Invoice::Item#set_amount, Invoice#set_total).
export default class extends Controller {
  static targets = ["total", "taxAmount", "taxExclusiveTotal", "totalToPay"]
  static values = { unpaidAmount: Number }

  connect () {
    this.formatter = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" })
    this.refresh()
  }

  refresh () {
    let total = 0

    this.element.querySelectorAll(".nested-form-wrapper").forEach(line => {
      const amountInput = line.querySelector("[data-invoice-item-input='amount']")
      const amount = this.number(line, "unit") * this.number(line, "quantity")
      if (amountInput) amountInput.value = amount.toFixed(2)
      if (this.isRemoved(line)) return

      total += amount
    })

    const taxExclusiveTotal = total / 1.2
    this.totalTarget.textContent = this.formatter.format(total)
    this.taxAmountTarget.textContent = this.formatter.format(total - taxExclusiveTotal)
    this.taxExclusiveTotalTarget.textContent = this.formatter.format(taxExclusiveTotal)
    this.totalToPayTarget.textContent = this.formatter.format(total + this.unpaidAmountValue)
  }

  number (line, kind) {
    const input = line.querySelector("[data-invoice-item-input='" + kind + "']")
    const value = input ? parseFloat(input.value) : NaN
    return Number.isNaN(value) ? 0 : value
  }

  isRemoved (line) {
    const destroyInput = line.querySelector("input[name*='_destroy']")
    return destroyInput !== null && destroyInput.value === "1"
  }
}
